import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=00df5978&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df5978",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00df5978')) {
      api.createRecord('00df5978', component.options)
    } else {
      api.reload('00df5978', component.options)
    }
    module.hot.accept("./Logout.vue?vue&type=template&id=00df5978&scoped=true", function () {
      api.rerender('00df5978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Logout.vue"
export default component.exports